const pgpcsPermission = [
  'PGPCS.TransactionReport',
  'PGPCS.TransactionReport.CreditCard',
  'PGPCS.TransactionReport.BCAVA',
  'PGPCS.TransactionReport.BNIVA',
  'PGPCS.TransactionReport.BRIVA',
  'PGPCS.TransactionReport.KlikBCA',
];

export default [
  {
    title: 'Dashboard',
    image: 'dashboard.svg',
    to: '/dashboard',
  },
  {
    title: 'Business Account',
    image: 'group.svg',
    to: '/bussinesaccount',
    isInternal: 0,
    permission: [
      'PGPCS',
      ...pgpcsPermission,
    ],
    children: [
      {
        title: 'Business Information',
        to: '/bussinesaccount/bussinesinformation',
      },
      {
        title: 'Payment Channel',
        to: '/setting/payment-channel',
        environment: 'sandbox',
      },
      {
        title: 'Payment Channel',
        to: '/setting/payment-channel-list',
        environment: 'production',
        permission: 'DUMMY',
      },
      {
        title: 'Log Activity',
        to: '/log-activity',
      },
    ],
  },
  {
    title: 'Payment Gateway',
    image: 'payment-gateway.svg',
    to: '/payment-gateway',
    permission: [
      'PGPCS',
      ...pgpcsPermission,
    ],
    children: [
      {
        title: 'Transaction Report',
        to: '/payment-gateway/transaction-report',
        permission: pgpcsPermission,
        children: [
          {
            title: 'Credit Card',
            to: '/payment-gateway/transaction-report/credit-card',
            permission: 'PGPCS.TransactionReport.CreditCard',
          },
          {
            title: 'Virtual Account',
            to: '/payment-gateway/transaction-report/online-transfer',
            permission: ['PGPCS.TransactionReport.BCAVA', 'PGPCS.TransactionReport.BNIVA',
              'PGPCS.TransactionReport.BRIVA', 'PGPCS.TransactionReport.MandiriVA',
              'PGPCS.TransactionReport.DanamonVA', 'PGPCS.TransactionReport.MaybankVA',
              'PGPCS.TransactionReport.PermataVA', 'PGPCS.TransactionReport.BSI',
              'PGPCS.TransactionReport.BNCVA', 'PGPCS.TransactionReport.BTCVA'],
            children: [
              {
                title: 'BCA',
                to: '/payment-gateway/transaction-report/online-transfer/bca',
                permission: 'PGPCS.TransactionReport.BCAVA',
              },
              {
                title: 'Mandiri Bill Payment',
                to: '/payment-gateway/transaction-report/online-transfer/mandiri-va',
                permission: 'PGPCS.TransactionReport.MandiriVA',
              },
              {
                title: 'BNI',
                to: '/payment-gateway/transaction-report/online-transfer/bni-va',
                permission: 'PGPCS.TransactionReport.BNIVA',
              },
              {
                title: 'BRI',
                to: '/payment-gateway/transaction-report/online-transfer/bri-va',
                permission: 'PGPCS.TransactionReport.BRIVA',
              },
              {
                title: 'Danamon',
                to: '/payment-gateway/transaction-report/online-transfer/danamon-va',
                permission: 'PGPCS.TransactionReport.DanamonVA',
              },
              {
                title: 'Maybank',
                to: '/payment-gateway/transaction-report/online-transfer/maybank-va',
                permission: 'PGPCS.TransactionReport.MaybankVA',
              },
              {
                title: 'Permata',
                to: '/payment-gateway/transaction-report/online-transfer/permata-va',
                permission: 'PGPCS.TransactionReport.PermataVA',
              },
              {
                title: 'BSI',
                to: '/payment-gateway/transaction-report/online-transfer/bsi',
                permission: 'PGPCS.TransactionReport.BSI',
              },
              {
                title: 'BNC',
                to: '/payment-gateway/transaction-report/online-transfer/bnc-va',
                permission: 'PGPCS.TransactionReport.BNCVA',
              },
              {
                title: 'BTN',
                to: '/payment-gateway/transaction-report/online-transfer/btn-va',
                permission: 'PGPCS.TransactionReport.BTNVA',
              },
              {
                title: 'Artha Graha',
                to: '/payment-gateway/transaction-report/online-transfer/arthagraha',
                permission: 'PGPCS.TransactionReport.ArthagrahaVA',
              },
            ],
          },
          {
            title: 'Internet Banking',
            to: '/payment-gateway/transaction-report/internet-banking',
            permission: ['PGPCS.TransactionReport.KlikBCA', 'PGPCS.TransactionReport.BCAKlikPay',
              'PGPCS.TransactionReport.BNIiPay', 'PGPCS.TransactionReport.PermataNet',
              'PGPCS.TransactionReport.BRIePay', 'PGPCS.TransactionReport.CIMBClick',
              'PGPCS.TransactionReport.BluBca'],
            children: [
              {
                title: 'BCA KlikPay',
                to: '/payment-gateway/transaction-report/internet-banking/bca-klikpay',
                permission: 'PGPCS.TransactionReport.BCAKlikPay',
              },
              {
                title: 'Klik BCA',
                to: '/payment-gateway/transaction-report/internet-banking/klik-bca',
                permission: 'PGPCS.TransactionReport.KlikBCA',
              },
              {
                title: 'OCTO Click',
                to: '/payment-gateway/transaction-report/internet-banking/cimb-click',
                permission: 'PGPCS.TransactionReport.CIMBClick',
              },
              {
                title: 'BNI IPay',
                to: '/payment-gateway/transaction-report/internet-banking/bni-ipay',
                permission: 'PGPCS.TransactionReport.BNIiPay',
              },
              {
                title: 'BRImo',
                to: '/payment-gateway/transaction-report/internet-banking/bri-epay',
                permission: 'PGPCS.TransactionReport.BRIePay',
              },
              {
                title: 'Permata Net',
                to: '/payment-gateway/transaction-report/internet-banking/permata-net',
                permission: 'PGPCS.TransactionReport.PermataNet',
              },
              {
                title: 'Blu BCA',
                to: '/payment-gateway/transaction-report/internet-banking/blu-bca',
                permission: 'PGPCS.TransactionReport.BluBca',
              },
            ],
          },
          {
            title: 'Instant Credit',
            to: '/payment-gateway/transaction-report/instant-credit',
            permission: ['PGPCS.TransactionReport.Indodana', 'PGPCS.TransactionReport.Kredivo',
              'PGPCS.TransactionReport.HomeCredit', 'PGPCS.TransactionReport.Atome',
              'PGPCS.TransactionReport.AEON'],
            children: [
              {
                title: 'Indodana',
                to: '/payment-gateway/transaction-report/instant-credit/indodana',
                permission: 'PGPCS.TransactionReport.Indodana',
              },
              {
                title: 'Kredivo',
                to: '/payment-gateway/transaction-report/instant-credit/kredivo',
                permission: 'PGPCS.TransactionReport.Kredivo',
              },
              {
                title: 'Home Credit',
                to: '/payment-gateway/transaction-report/instant-credit/homecredit',
                permission: 'PGPCS.TransactionReport.HomeCredit',
              },
              {
                title: 'Atome',
                to: '/payment-gateway/transaction-report/instant-credit/atome',
                permission: 'PGPCS.TransactionReport.Atome',
              },
              {
                title: 'AEON',
                to: '/payment-gateway/transaction-report/instant-credit/aeon',
                permission: 'PGPCS.TransactionReport.AEON',
              },
            ],
          },
          {
            title: 'E-Money & E-Wallet',
            to: '/payment-gateway/transaction-report/e-money',
            permission: ['PGPCS.TransactionReport.DANA', 'PGPCS.TransactionReport.LinkAja',
              'PGPCS.TransactionReport.ShopeePay', 'PGPCS.TransactionReport.BCASakuku',
              'PGPCS.TransactionReport.OVO', 'PGPCS.TransactionReport.BayarInd',
              'PGPCS.TransactionReport.QRIS'],
            children: [
              {
                title: 'DANA',
                to: '/payment-gateway/transaction-report/e-money/dana',
                permission: 'PGPCS.TransactionReport.DANA',
              },
              {
                title: 'BCA Sakuku',
                to: '/payment-gateway/transaction-report/internet-banking/bca-sakuku',
                permission: 'PGPCS.TransactionReport.BCASakuku',
              },
              {
                title: 'Bayarind',
                to: '/payment-gateway/transaction-report/internet-banking/bayarind',
                permission: 'PGPCS.TransactionReport.BayarInd',
              },
              {
                title: 'LinkAjaTCash',
                to: '/payment-gateway/transaction-report/e-money/tcash',
                permission: 'PGPCS.TransactionReport.LinkAja',
              },
              // {
              //   title: 'LinkAjaMeCash',
              //   to: '/payment-gateway/transaction-report/e-money/mandiri-ecash',
              //   permission: 'PGPCS.TransactionReport.LinkAja',
              // },
              {
                title: 'ShopeePay',
                to: '/payment-gateway/transaction-report/e-money/shopeepay',
                permission: 'PGPCS.TransactionReport.ShopeePay',
              },
              {
                title: 'OVO',
                to: '/payment-gateway/transaction-report/e-money/ovo',
                permission: 'PGPCS.TransactionReport.OVO',
              },
              {
                title: 'QRIS',
                to: '/payment-gateway/transaction-report/e-money/qris',
                permission: 'PGPCS.TransactionReport.QRIS',
              },
            ],
          },
          {
            title: 'Retail',
            to: '/payment-gateway/transaction-report/retail',
            permission: ['PGPCS.TransactionReport.Alfamart'],
            children: [
              {
                title: 'Alfamart',
                to: '/payment-gateway/transaction-report/retail/alfamart',
                permission: 'PGPCS.TransactionReport.Alfamart',
              },
            ],
          },
          // {
          //   title: 'Other',
          //   to: '/payment-gateway/transaction-report/other',
          //   permission: ['PGPCS.TransactionReport.EasyInvoice'],
          //   children: [
          //     {
          //       title: 'Easy Invoice',
          //       to: '/payment-gateway/transaction-report/other/easyinvoice',
          //       permission: 'PGPCS.TransactionReport.EasyInvoice',
          //     },
          //   ],
          // },
        ],
      },
      {
        title: 'Payment Card Setting',
        // image: 'disbursement.svg',
        to: 'https://securetest.bayarind.id/',
        permission: 'PGPCS.TransactionReport.CreditCard',
        environment: 'sandbox',
      },
      {
        title: 'Payment Card Setting',
        // image: 'disbursement.svg',
        to: 'https://secure.bayarind.id/',
        permission: 'PGPCS.TransactionReport.CreditCard',
        environment: 'production',
      },
    ],
  },
  {
    title: 'Easy Invoice',
    image: 'receipt.svg',
    to: '/easyinvoice',
    permission: 'EasyInvoice.TransactionReport',
    children: [
      {
        title: 'Invoice',
        to: '/easyinvoice/einvoice',
        permission: 'EasyInvoice.Invoice.Add',
        children: [
          {
            title: 'Create Invoice',
            to: '/easyinvoice/einvoice/createinvoice',
            permission: 'EasyInvoice.Invoice.Add',
          },
          {
            title: 'Invoice Batch',
            to: '/easyinvoice/einvoice/invoicebatch',
            permission: 'EasyInvoice.Invoice.Add',
          },
        ],
      },
      {
        title: 'Transaction',
        to: '/easyinvoice/etransaction',
        permission: ['EasyInvoice.Transaction.Report',
          'EasyInvoice.Transaction.Report.ListInvoice',
          'EasyInvoice.Transaction.Report.BulkReport'],
        children: [
          {
            title: 'List Transaction',
            to: '/easyinvoice/etransaction/listtransaction',
            permission: 'EasyInvoice.Transaction.Report',
          },
          {
            title: 'List Invoice',
            to: '/easyinvoice/etransaction/listinvoice',
            permission: 'EasyInvoice.Transaction.Report.ListInvoice',
          },
          {
            title: 'List Bulk Invoice',
            to: '/easyinvoice/etransaction/listbulkinvoice',
            permission: 'EasyInvoice.Transaction.Report.BulkReport',
          },
        ],
      },
      {
        title: 'Configuration',
        to: '/easyinvoice/configuration',
        permission: ['EasyInvoice.Merchant.Profile.Payment.Page.AddEdit', 'EasyInvoice.Merchant.List.View'],
        children: [
          {
            title: 'Profile',
            to: '/easyinvoice/configuration/profile',
            permission: 'EasyInvoice.Merchant.Profile.Payment.Page.AddEdit',
          },
          {
            title: 'Products',
            to: '/easyinvoice/configuration/product',
            permission: 'EasyInvoice.Manage.Product.ViewSearch',
          },
          {
            title: 'Email',
            to: '/easyinvoice/configuration/email',
            permission: 'EasyInvoice.Email.Manage',
          },
          {
            title: 'SMS',
            to: '/easyinvoice/configuration/sms',
            permission: 'EasyInvoice.SMS.Manage',
          },
          {
            title: 'List Merchant',
            to: '/easyinvoice/configuration/merchant',
            permission: 'EasyInvoice.Merchant.List.View',
          },
          {
            title: 'List Super Admin Merchant',
            to: '/easyinvoice/configuration/superadminmerchant',
            permission: ['EasyInvoice.Merchant.SuperAdmin.Manage'],
          },
          {
            title: 'List Sprint User',
            to: '/easyinvoice/configuration/sprintuser',
            permission: 'EasyInvoice.Bayarind.User.View"',
          },
        ],
      },
    ],
  },
  {
    title: 'One Pay',
    image: 'contactless-payment-circle.svg',
    to: '/onepay',
    permission: ['OnePay.TrasanctionReport',
    ],
    children: [
      {
        title: 'OnePay Dashboard',
        to: '/onepay/onepaydashboard',
      },
      {
        title: 'OnePay Transaction',
        to: '/onepay/onepaytransaction',
        permission: 'OnePay.Trasanction.Report',
      },
      {
        title: 'OnePay Merchant',
        to: '/onepay/onepaymerchant',
        permission: 'OnePay.Merchant.Supervisor.Create',
      },
      {
        title: 'OnePay Merchant Manager',
        to: '/onepay/onepaymerchantmanager',
        permission: 'OnePay.Merchant.Supervisor.Create',
      },
    ],
  },
  {
    title: 'Billing',
    image: 'group.svg',
    to: '/billing',
    permission: ['Billing.ReconMenu.Merchant', 'Billing.ReconMenu',
      'Billing.InvoiceMenu',
    ],
    children: [
      {
        title: 'Reconciliation Data',
        to: '/billing/recon-data/merchant',
        permission: 'Billing.ReconMenu.Merchant',
        isInternal: 1,
      },
      {
        title: 'Reconciliation Data',
        to: '/billing/recon-data/external',
        permission: 'Billing.ReconMenu.Merchant',
        isInternal: 0,
      },
      {
        title: 'Reconciliation Data',
        to: '/billing/recon-data/internal',
        permission: 'Billing.ReconMenu',
      },
      {
        title: 'Invoice',
        to: '/billing/invoice',
        permission: 'Billing.InvoiceMenu',
      },
    ],
  },
  {
    title: 'Disbursements',
    image: 'disbursement.svg',
    to: '/auto-disbursement',
    permission: ['PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch.HideDisbursement',
      'PGPCS.DisbursementConfigurator.AccountStatement.Create.HideDisbursement',
      'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch.HideDisbursement',
      'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create.HideDisbursement',
      'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch.HideDisbursement',
      'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve.HideDisbursement'],
    children: [
      {
        title: 'Account Statement',
        to: '/auto-disbursement/account-statement',
        permission: ['PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch.HideDisbursement',
          'PGPCS.DisbursementConfigurator.AccountStatement.Create.HideDisbursement'],
      },
      {
        title: 'Upload Data Disbursement',
        to: '/auto-disbursement/upload-request',
        permission: ['PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch.HideDisbursement',
          'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create.HideDisbursement'],
      },
      {
        title: 'Approval Disbursement',
        to: '/auto-disbursement/approval-request',
        permission: ['PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch.HideDisbursement',
          'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve.HideDisbursement'],
      },
      {
        title: 'Other Business Report',
        to: '/auto-disbursement/other-business-report',
        permission: 'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.HideDisbursement',
        isInternal: 0,
      },

    ],
  },
  {
    title: 'Disbursements Management',
    image: 'disbursement.svg',
    to: '/auto-disbursement-management',
    permission: 'PGPCS.DisbursementManagement.HideDisbursement',
    children: [
      {
        title: 'Merchant Account Statement',
        to: '/auto-disbursement-management/merchant-account-statement',
        permission: ['PGPCS.DisbursementManagement.AccountStatement.ViewSearch.HideDisbursement'],
        isInternal: 1,
      },
      {
        title: 'Businesss List',
        to: '/auto-disbursement-management/bussiness-list',
        permission: ['PGPCS.DisbursementManagement.BusinessList.ViewSearch.HideDisbursement'],
      },
      {
        title: 'Partnership List',
        to: '/auto-disbursement-management/partnership-list',
        permission: ['PGPCS.DisbursementManagement.BusinessList.ViewSearch.HideDisbursement'],
        isInternal: 1,
      },
      {
        title: 'Auto Flag',
        to: '/auto-disbursement-management/auto-flag',
        permission: 'PGPCS.DisbursementManagement.HideDisbursement',
        isInternal: 1,
      },
      {
        title: 'Mapping Bank Code',
        to: '/auto-disbursement-management/mapping-bank-code',
        permission: 'PGPCS.DisbursementManagement.HideDisbursement',
        isInternal: 1,
      },
      // {
      //   title: 'Merchant Information',
      //   to: '#Merchant Information',
      //   permission: 'PGPCS.DisbursementManagement',
      // },
      // {
      //   title: 'Bank Information',
      //   to: '#Bank Information',
      //   permission: 'PGPCS.DisbursementManagement.BankInformation',
      // },
      // {
      //   title: 'Account Statement',
      //   to: '#Account Statement ',
      //   permission: 'PGPCS.DisbursementManagement.AccountStatement',
      // },
      // {
      //   title: 'Bank Service',
      //   to: '/auto-disbursement-management/bank-service',
      //   permission: 'PGPCS.DisbursementManagement.BankService',
      //   children: [
      //     // {
      //     //   title: 'Balance & Mutation Bank',
      //     //   to: '#Balance & Mutation Bank',
      //     //   permission: 'PGPCS.DisbursementManagement.BankService.BalanceMutation',
      //     // },
      //     // {
      //     //   title: 'Summary API Bank Charge',
      //     //   to: '#Summary API Bank Charge',
      //     //   permission: 'PGPCS.DisbursementManagement.BankService.SummaryAPIBankCharge',
      //     // },
      //     {
      //       title: 'Summary API Merchant Charge',
      //       to: '/auto-disbursement-management/bank-service/merchant-charge',
      //       permission: 'PGPCS.DisbursementManagement.BankService.SummaryAPIMerchantCharge',
      //     },
      //   ],
      // },
    ],
  },
  {
    title: 'Bayarind',
    image: 'bayarind2.svg',
    to: '/bayarind',
    permission: ['BayarInd.Recon.DataBank.Upload', 'BayarInd.Recon.DataRecon.Matching',
      'BayarInd.Recon.TopUp.ViewDownload', 'BayarInd.Recon.DataRecon.ViewDownload'],
    children: [
      {
        title: 'Top Up',
        to: '/bayarind/top-up',
        permission: ['BayarInd.Recon.DataBank.Upload', 'BayarInd.Recon.DataRecon.Matching',
          'BayarInd.Recon.TopUp.ViewDownload', 'BayarInd.Recon.DataRecon.ViewDownload',
          'BayarInd.Recon.BankConfiguration.AddEditDelete', 'BayarInd.Recon.BankConfiguration.ViewSearch',
        ],
        children: [
          {
            title: 'Reconciliation',
            to: '/bayarind/top-up/reconciliation',
            permission: ['BayarInd.Recon.DataBank.Upload', 'BayarInd.Recon.DataRecon.Matching',
              'BayarInd.Recon.TopUp.ViewDownload'],
          },
          {
            title: 'Report Reconciliation',
            to: '/bayarind/top-up/report-reconciliation',
            permission: 'BayarInd.Recon.DataRecon.ViewDownload',
          },
          {
            title: 'Bank Configuration',
            to: '/bayarind/top-up/bankconfiguration',
            permission: ['BayarInd.Recon.BankConfiguration.AddEditDelete',
              'BayarInd.Recon.BankConfiguration.ViewSearch',
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Merchant Lead',
    image: 'merchant-lead.svg',
    to: '/merchant-lead',
    isInternal: 1,
    permission: 'MerchantLead.Merchant.List.ViewSearch',
  },
  {
    title: 'Account Management',
    image: 'group.svg',
    to: '/account-management',
    isInternal: 1,
    permission: 'AccountManagement.Business.View',
  },
  {
    title: 'Group Management',
    image: 'group.svg',
    to: '/group-management',
    permission: 'Setting.GroupManagement',
    children: [
      {
        title: 'Internal Group',
        to: '/group-management/internal',
        permission: 'Setting.GroupManagement',
      },
      {
        title: 'External Group',
        to: '/group-management/external',
        permission: 'Setting.GroupManagement',
      },
    ],
  },
  // {
  //   title: 'Merchant Lead Tab',
  //   image: 'merchant-lead.svg',
  //   to: '/merchant-lead-tab',
  //   permission: 'Setting.GroupManagement',
  // },
  {
    title: 'Invoice',
    image: 'group.svg',
    to: '/invoice',
    permission: 'Setting.GroupManagement',
  },
  {
    title: 'Integration',
    image: 'integration.svg',
    to: '/integration',
    environment: 'sandbox',
    isInternal: 0,
  },
  {
    title: 'Reconciliation',
    image: 'setting.svg',
    to: '/reconciliation',
    isInternal: 1,
    permission: ['BayarInd.Recon.DataBank.Upload', 'BayarInd.Recon.DataRecon.Matching',
      'BayarInd.Recon.TopUp.ViewDownload', 'BayarInd.Recon.DataRecon.ViewDownload'],
    children: [
      {
        title: 'Upload Reconciliation Data',
        to: '/reconciliation/upload',
      },
      {
        title: 'View Reconciliation Data',
        to: '/ccc',
        children: [
          {
            title: 'Alterra',
            to: '/reconciliation/stg/stgAlterra',
          },
          {
            title: 'BMS',
            to: '/reconciliation/stg/stgBms',
          },
          {
            title: 'GoSend',
            to: '/reconciliation/stg/stgGosend',
          },
          {
            title: 'GoSend (Sprint)',
            to: '/reconciliation/stg/stgGosendSprint',
          },
          {
            title: 'IDN',
            to: '/reconciliation/stg/stgIdn',
          },
          {
            title: 'Credit Card',
            to: '/reconciliation/stg/stgCc',
          },
          {
            title: 'PPOB',
            to: '/reconciliation/stg/stgPpob',
          },
          {
            title: 'PPOB (PCS)',
            to: '/reconciliation/stg/stgPpobPcs',
          },
          {
            title: 'QRIS',
            to: '/reconciliation/stg/stgQrisJalin',
          },
          {
            title: 'JALIN',
            to: '/reconciliation/stg/stgQrisBackOffice',
          },
          {
            title: 'Order',
            to: '/reconciliation/stg/stgOrder',
          },
          {
            title: 'Order (Paid)',
            to: '/reconciliation/stg/stgOrderPaid',
          },
          {
            title: 'Order (Pasarind)',
            to: '/reconciliation/stg/stgOrderPasarind',
          },
          {
            title: 'Transaction (Bayarind)',
            to: '/reconciliation/stg/stgTransBayarind',
          },
          {
            title: 'Transaction (Pasarind)',
            to: '/reconciliation/stg/stgTransPasarind',
          },
          {
            title: 'BCA One Klik',
            to: '/reconciliation/stg/stgBcaOneKlik',
          },
        ],
      },
      {
        title: 'Process Reconciliation',
        to: '/reconciliation/process/list',
      },
      {
        title: 'Reconciliation Result',
        to: '/reconciliation/result',
        children: [
          {
            title: 'Report PPOB',
            to: '/reconciliation/stg/reportPpob',
          },
          {
            title: 'Report Go Send',
            to: '/reconciliation/stg/reportGosend',
          },
          {
            title: 'Report QRIS',
            to: '/reconciliation/stg/reportQris',
          },

        ],
      },
    ],
  },
  {
    title: 'Setting',
    image: 'setting.svg',
    to: '/setting',
    children: [
      {
        title: 'User Profile',
        to: '/setting/profile',
      },
      {
        title: 'User Management',
        to: '/setting/user-management',
        permission: 'Setting.UserManagement',
        children: [
          {
            title: 'Internal',
            to: '/setting/user-management/internal',
            permission: 'Setting.UserManagement',
          },
          {
            title: 'External',
            to: '/setting/user-management/external',
            permission: 'Setting.UserManagement',
          },
        ],
      },
      {
        title: 'User Management',
        to: '/setting/user-management/external',
        permission: 'Setting.UserManagementMerchant',
      },
    ],
  },
  {
    title: 'Log Activity',
    image: 'setting.svg',
    to: '/log-activity',
    isInternal: 1,
    children: [
      {
        title: 'Internal',
        to: '/log-activity/internal',
        permission: 'Setting.UserManagement',
      },
      {
        title: 'External',
        to: '/log-activity/external',
        permission: 'Setting.UserManagement',
      },
    ],
  },
];

